import { render, staticRenderFns } from "./JobViewUserInfoCard.vue?vue&type=template&id=48cf1b8a"
import script from "./JobViewUserInfoCard.vue?vue&type=script&lang=js"
export * from "./JobViewUserInfoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports